import React from "react";
import { faqs, images } from "../mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQ = () => {
  return (
    <section className="relative py-24 bg-gray-50">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-10"
        style={{ backgroundImage: `url(${images.faqBg})` }}
      />
      <div className="relative max-w-4xl mx-auto px-6">
        <h2 className="font-display text-center text-4xl md:text-5xl font-bold">
          FAQ<span className="text-[color:var(--brand-red)]">&apos;S</span>
        </h2>
        <div className="h-1 w-16 bg-[color:var(--brand-red)] mx-auto mt-4 mb-12" />

        <Accordion type="single" collapsible className="w-full space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white rounded-md border border-gray-200 px-5 shadow-sm data-[state=open]:border-[color:var(--brand-red)] transition-colors"
            >
              <AccordionTrigger className="text-left font-semibold text-gray-800 hover:text-[color:var(--brand-red)] py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed pb-4">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
